/* Khroom Blog-Layout "pro" – Kaufelemente, Tabellen-Karten, Video-Vorschau, Kaufleiste */
(function () {
  var root = document.querySelector('.kb-pro');
  var dataEl = document.getElementById('kb-pro-data');
  if (!root || !dataEl) return;
  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var ALL = data.products || {}, T = data.i18n || {}, P = {};
  Object.keys(ALL).forEach(function (k) { if (ALL[k].available) P[k] = ALL[k]; });
  var prose = root.querySelector('.prose');
  if (!prose) return;

  function handleOf(href) {
    var m = (href || '').match(/\/products\/([^/?#"]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function rateHtml(p) {
    if (!p.rating) return '';
    var r = parseFloat(p.rating), txt = r.toFixed(1).replace('.', ',');
    return '<span class="kb-rate"><span class="kb-stars" style="--r:' + r + '">★★★★★</span>' + txt +
      (p.count ? ' (' + p.count + ' ' + esc(T.reviews) + ')' : '') + '</span>';
  }
  function shortTitle(p) {
    return String(p.title).split(' - ')[0].split(' (')[0].replace(/^Schnorchelmaske\s+/i, '').trim();
  }
  function priceHtml(p) {
    return '<span class="kb-price">' + esc(p.price) + (p.compare ? '<s>' + esc(p.compare) + '</s>' : '') + '</span>';
  }

  try {
  /* 1) Kaufzeile direkt unter dem Produktbild jedes Produktblocks */
  prose.querySelectorAll('.smt-review').forEach(function (box) {
    var cta = box.querySelector('a.smt-cta');
    var h = cta && handleOf(cta.getAttribute('href'));
    var p = h && P[h];
    if (!p) return;
    var img = box.querySelector('img');
    var row = document.createElement('div');
    row.className = 'kb-buy';
    row.innerHTML = '<div class="kb-buy__info">' + priceHtml(p) + rateHtml(p) + '</div>' +
      '<a class="kb-btn" href="' + esc(p.url) + '">' + esc(T.offer) + '</a>';
    if (img && img.parentNode === box) img.insertAdjacentElement('afterend', row);
    else box.insertBefore(row, box.firstChild);
  });

  } catch (e) { console.warn("kb-pro 1)", e); }
  try {
  /* 2) Tabellen: Spaltennamen für die Handy-Kartenansicht */
  prose.querySelectorAll('table').forEach(function (tbl) {
    var heads = Array.prototype.map.call(tbl.querySelectorAll('thead th'), function (th) { return th.textContent.trim(); });
    var ranked = Array.prototype.some.call(tbl.querySelectorAll('tbody tr'), function (tr) { return tr.children.length > 1 && /^\d+$/.test(tr.children[0].textContent.trim()); });
    if (!ranked) tbl.classList.add('kb-tbl--plain');
    tbl.querySelectorAll('tbody tr').forEach(function (tr) {
      var cells = tr.children;
      Array.prototype.forEach.call(cells, function (td, i) { if (heads[i]) td.setAttribute('data-label', heads[i]); });
      if (cells.length > 1 && /^\d+$/.test(cells[0].textContent.trim())) {
        var s = document.createElement('span');
        s.className = 'kb-rank';
        s.textContent = cells[0].textContent.trim();
        cells[1].insertBefore(s, cells[1].firstChild);
      }
    });
  });

  } catch (e) { console.warn("kb-pro 2)", e); }
  try {
  /* 3) YouTube erst beim Klick laden */
  prose.querySelectorAll('iframe[src*="youtube"]').forEach(function (ifr) {
    var m = ifr.src.match(/embed\/([\w-]{6,})/);
    if (!m) return;
    var id = m[1], title = ifr.getAttribute('title') || '';
    var wrap = ifr.parentElement;
    var host = (wrap && wrap.children.length === 1 && /padding-bottom/.test(wrap.getAttribute('style') || '')) ? wrap : ifr;
    var isShort = !!ifr.closest('.kb-short');
    if (isShort) host = ifr;
    var f = document.createElement('div');
    f.className = 'kb-yt' + (isShort ? ' kb-yt--short' : '');
    f.innerHTML = '<img loading="lazy" alt="' + esc(title) + '" src="https://i.ytimg.com/vi/' + id + '/hqdefault.jpg">' +
      '<button type="button" aria-label="' + esc(T.play) + '"></button>';
    f.addEventListener('click', function () {
      f.innerHTML = '<iframe src="https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0" title="' + esc(title) +
        '" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>';
    }, { once: true });
    host.replaceWith(f);
  });

  } catch (e) { console.warn("kb-pro 3)", e); }
  try {
  /* 4) Fazit: Empfehlungs-Karten statt Linkliste + Vertrauensleiste */
  var fazit = prose.querySelector('h2#fazit') || Array.prototype.slice.call(prose.querySelectorAll('h2')).pop();
  var recoEl = null;
  if (fazit) {
    var list = null, n = fazit.nextElementSibling;
    while (n && n.tagName !== 'H2' && n.tagName !== 'H3') {
      if (n.classList && n.classList.contains('smt-snippet') && n.querySelector('a[href*="/products/"]')) { list = n; break; }
      n = n.nextElementSibling;
    }
    if (list) {
      var awards = {};
      prose.querySelectorAll('table tbody tr').forEach(function (tr) {
        var a = tr.querySelector('a[href*="/products/"]'), b = tr.querySelector('.smt-badge');
        if (a && b) awards[handleOf(a.getAttribute('href'))] = b.textContent.trim();
      });
      var picks = [], rest = [];
      list.querySelectorAll('p').forEach(function (para) {
        var a = para.querySelector('a[href*="/products/"]');
        var h = a && handleOf(a.getAttribute('href'));
        if (!h || !P[h]) return;
        var label = para.textContent.split('–')[1];
        label = label ? label.split(',')[0].trim() : '';
        (picks.length < 3 ? picks : rest).push({ h: h, a: a, label: awards[h] || label });
      });
      if (picks.length >= 2) {
        recoEl = document.createElement('div');
        recoEl.className = 'kb-reco';
        recoEl.innerHTML = picks.map(function (x, i) {
          var p = P[x.h];
          return '<div class="kb-card kb-reveal' + (i === 0 ? ' is-top' : '') + '">' +
            (x.label ? '<span class="kb-card__badge">' + esc(x.label) + '</span>' : '') +
            '<img loading="lazy" src="' + esc(p.img) + '" alt="' + esc(p.title) + '">' +
            '<div class="kb-card__body"><div class="kb-card__title">' + esc(shortTitle(p)) + '</div>' + rateHtml(p) + priceHtml(p) + '</div>' +
            '<a class="kb-btn" href="' + esc(p.url) + '">' + esc(T.offer) + '</a></div>';
        }).join('');
        var frag = [recoEl];
        if (rest.length) {
          var more = document.createElement('p');
          more.className = 'kb-more';
          more.innerHTML = esc(T.more) + ': ' + rest.map(function (x) { return '<a href="' + esc(P[x.h].url) + '">' + esc(x.a.textContent.trim()) + '</a>'; }).join(' · ');
          frag.push(more);
        }
        if (data.trust && data.trust.length) {
          var tr = document.createElement('div');
          tr.className = 'kb-trust';
          tr.innerHTML = data.trust.map(function (t) { return '<span>' + esc(t) + '</span>'; }).join('');
          frag.push(tr);
        }
        var anchor = list;
        frag.forEach(function (el) { anchor.insertAdjacentElement('afterend', el); anchor = el; });
        list.style.display = 'none';
      }
    }
  }

  } catch (e) { console.warn("kb-pro 4)", e); }
  try {
  /* 5) Feste Kaufleiste am Handy (erste empfohlene Maske) */
  var firstCta = prose.querySelector('a.smt-cta');
  var topH = firstCta && handleOf(firstCta.getAttribute('href'));
  var topP = topH && P[topH];
  var startEl = prose.querySelector('table') || prose.querySelector('.smt-review');
  if (topP && startEl) {
    var bar = document.createElement('div');
    bar.className = 'kb-bar';
    bar.innerHTML = '<img src="' + esc(topP.img) + '" alt="">' +
      '<div class="kb-bar__txt"><small>' + esc(T.reco) + '</small><b>' + esc(shortTitle(topP)) + '</b><span>' + esc(topP.price) + '</span></div>' +
      '<a class="kb-btn" href="' + esc(topP.url) + '">' + esc(T.view) + '</a>';
    document.body.appendChild(bar);
    var stopEl = recoEl || fazit;
    var ticking = false;
    var update = function () {
      ticking = false;
      if (window.innerWidth >= 1000) { bar.classList.remove('is-on'); document.body.classList.remove('kb-bar-up'); return; }
      var vh = window.innerHeight;
      var started = startEl.getBoundingClientRect().bottom < vh * 0.5;
      var stopped = stopEl ? stopEl.getBoundingClientRect().top < vh : false;
      var on = started && !stopped;
      bar.classList.toggle('is-on', on);
      document.body.classList.toggle('kb-bar-up', on);
    };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  } catch (e) { console.warn("kb-pro 5)", e); }
  /* ================= Visuelle Aufbereitung ================= */
  var content = prose.querySelector('.smt-content') || prose.querySelector('.kco-content') || prose.querySelector('.kr-content') || prose;
  /* Freigegebene Texte (kco-/kr-Beiträge): nur Optik, keinerlei Textänderung */
  var kr = content.classList.contains('kr-content');
  var strict = kr || content.classList.contains('kco-content');
  if (strict) root.classList.add('kb-strict');
  if (kr) root.classList.add('kb-kr');
  var kids = function () { return Array.prototype.slice.call(content.children); };
  function ring(score, max, label) {
    var C = 113.1, v = Math.max(0, Math.min(1, score / max));
    return '<span class="kb-ring" style="--off:' + (C * (1 - v)).toFixed(1) + '"><svg viewBox="0 0 44 44" aria-hidden="true">' +
      '<circle class="kb-ring__bg" cx="22" cy="22" r="18"></circle><circle class="kb-ring__fg" cx="22" cy="22" r="18"></circle></svg>' +
      '<b>' + (label ? String(label) : String(score).replace('.', ',')) + '</b></span>';
  }
  function num(s) { return parseFloat(String(s).replace(',', '.')); }
  function findProductLink(name) {
    var n = name.replace(/^Khroom\s+/i, '').toLowerCase(), hit = null;
    content.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      if (!hit && a.textContent.toLowerCase().replace(/^khroom\s+/, '').trim() === n) hit = a;
    });
    return hit;
  }

  try {
  /* A) Transparenzhinweis ans Ende */
  var firstH2 = content.querySelector('h2');
  kids().forEach(function (el) {
    if (firstH2 && (el.compareDocumentPosition(firstH2) & Node.DOCUMENT_POSITION_FOLLOWING) &&
        el.classList.contains('smt-trust')) {
      el.classList.add('kb-footnote');
      content.appendChild(el);
    }
  });

  } catch (e) { console.warn("kb-pro A)", e); }
  try {
  /* B) "Das Wichtigste auf einen Blick" als Übersichts-Panel */
  var snip = content.querySelector('.smt-snippet');
  if (snip && firstH2 && (snip.compareDocumentPosition(firstH2) & Node.DOCUMENT_POSITION_FOLLOWING)) {
    var ps = Array.prototype.slice.call(snip.querySelectorAll('p'));
    var title = ps.length && !/:\s*\S/.test(ps[0].textContent.replace(/:\s*$/, '')) ? ps.shift().textContent.replace(/:\s*$/, '') : '';
    var tiles = [], foot = [];
    ps.forEach(function (para) {
      var st = para.querySelector('strong');
      if (!st) return;
      var label = st.textContent.replace(/:\s*$/, '').trim();
      var rest = para.textContent.slice(para.textContent.indexOf(st.textContent) + st.textContent.length).trim();
      var m = rest.match(/^(.+?)\s*\((\d+[,.]\d)\s*\/\s*10\)\s*[–-]\s*(.+)$/);
      if (m) tiles.push({ label: label, name: m[1].trim(), score: m[2], why: m[3].trim() });
      else foot.push({ label: label, text: rest });
    });
    if (tiles.length >= 2) {
      var panel = document.createElement('div');
      panel.className = 'kb-keyfacts kb-reveal';
      panel.innerHTML = (title ? '<div class="kb-kf__head">' + esc(title) + '</div>' : '') +
        '<div class="kb-kf__grid">' + tiles.map(function (t, i) {
          var a = findProductLink(t.name), h = a && handleOf(a.getAttribute('href')), pr = h && ALL[h];
          var tag = pr ? 'a' : 'div';
          return '<' + tag + ' class="kb-kf__tile' + (i === 0 ? ' is-top' : '') + '"' + (pr ? ' href="' + esc(pr.url) + '"' : '') + '>' +
            '<span class="kb-kf__label">' + esc(t.label) + '</span>' +
            '<span class="kb-kf__row">' + ring(num(t.score), 10, t.score) + '<span class="kb-kf__name">' + esc(t.name.replace(/^Khroom\s+/i, '')) + '</span></span>' +
            '<span class="kb-kf__why">' + esc(t.why) + '</span>' +
            (pr ? '<span class="kb-kf__go">' + esc(pr.available ? pr.price : T.view) + ' <i>→</i></span>' : '') + '</' + tag + '>';
        }).join('') + '</div>' +
        foot.map(function (f) { return '<div class="kb-kf__foot"><span class="kb-shield"></span><span><strong>' + esc(f.label) + ':</strong> ' + esc(f.text) + '</span></div>'; }).join('');
      snip.replaceWith(panel);
    }
  }

  } catch (e) { console.warn("kb-pro B)", e); }
  try {
  /* C) Inhaltsverzeichnis: Kachel-Optik + seitliche Navigation am Desktop */
  var toc = content.querySelector('.smt-toc, .kco-toc, nav');
  var tocLinks = toc ? Array.prototype.slice.call(toc.querySelectorAll('a[href^="#"]')) : [];
  if (toc && tocLinks.length >= 3) {
    toc.classList.add('kb-toc', 'kb-reveal');
    tocLinks.forEach(function (a, i) { a.insertAdjacentHTML('afterbegin', '<span class="kb-toc__n">' + String(i + 1).padStart(2, '0') + '</span>'); });
    var side = document.createElement('aside');
    side.className = 'kb-side';
    var tocTitle = toc.querySelector('h2,h3,h4');
    side.innerHTML = '<div class="kb-side__t">' + esc(tocTitle ? tocTitle.textContent : '') + '</div>' +
      tocLinks.map(function (a) { return '<a href="' + esc(a.getAttribute('href')) + '">' + esc(a.textContent.replace(/^\d+/, '').trim()) + '</a>'; }).join('');
    root.appendChild(side);
    var sideLinks = side.querySelectorAll('a');
    var targets = tocLinks.map(function (a) { return document.getElementById(decodeURIComponent(a.getAttribute('href').slice(1))); });
    var onScrollToc = function () {
      var y = window.innerHeight * 0.3, act = -1;
      targets.forEach(function (t, i) { if (t && t.getBoundingClientRect().top < y) act = i; });
      sideLinks.forEach(function (l, i) { l.classList.toggle('is-act', i === act); });
      var r = content.getBoundingClientRect();
      side.classList.toggle('is-on', r.top < 120 && r.bottom > window.innerHeight * 0.6);
    };
    window.addEventListener('scroll', onScrollToc, { passive: true });
    onScrollToc();
  }

  } catch (e) { console.warn("kb-pro C)", e); }
  try {
  /* D) Kapitelüberschriften mit Nummer */
  content.querySelectorAll('h2').forEach(function (h2) {
    if (strict && !kr) { h2.classList.add('kb-reveal'); return; }
    var m = h2.textContent.trim().match(/^(\d+)\.\s+(.+)$/);
    if (m) h2.innerHTML = '<span class="kb-num">' + m[1].padStart(2, '0') + '</span><span class="kb-h2t">' + esc(m[2]) + '</span>';
    h2.classList.add('kb-h2', 'kb-reveal');
  });

  } catch (e) { console.warn("kb-pro D)", e); }
  try {
  /* E) Bewertungskriterien mit Gewichtungsbalken */
  var crits = [];
  content.querySelectorAll('h3').forEach(function (h3) {
    var m = h3.textContent.trim().match(/^(?:(\d+\.\d+)\s+)?(.+?)\s*\(([^()]*?)(\d+)\s*%\)\s*$/);
    if (!m || h3.closest('.smt-review')) return;
    var card = document.createElement('div');
    card.className = 'kb-crit kb-reveal';
    h3.parentNode.insertBefore(card, h3);
    var n = h3.nextElementSibling;
    card.appendChild(h3);
    while (n && !/^H[23]$/.test(n.tagName) && !(n.classList && n.classList.contains('kb-crit'))) {
      var nx = n.nextElementSibling; card.appendChild(n); n = nx;
    }
    h3.innerHTML = (m[1] ? '<span class="kb-crit__n">' + esc(m[1]) + '</span>' : '') + esc(m[2]);
    card.insertAdjacentHTML('beforeend', '');
    var w = parseInt(m[4], 10);
    var wl = m[3].replace(/[:\s]+$/, '').trim();
    h3.insertAdjacentHTML('afterend', '<div class="kb-crit__w"><span>' + esc(wl) + '</span><span class="kb-wbar"><i data-w="' + w + '"></i></span><b>' + w + ' %</b></div>');
    crits.push({ el: card, w: w });
  });
  if (crits.length >= 3) {
    var maxW = Math.max.apply(null, crits.map(function (c) { return c.w; }));
    var grid = document.createElement('div');
    grid.className = 'kb-crit-grid';
    crits[0].el.parentNode.insertBefore(grid, crits[0].el);
    crits.forEach(function (c, i) {
      c.el.querySelector('.kb-wbar i').style.setProperty('--w', (c.w / maxW * 100).toFixed(0) + '%');
      if (i === 0) c.el.classList.add('is-wide');
      c.el.style.transitionDelay = (i % 2) * 0.08 + 's';
      grid.appendChild(c.el);
    });
  }

  } catch (e) { console.warn("kb-pro E)", e); }
  try {
  /* F) Noten in der Tabelle als Balken */
  content.querySelectorAll('table .smt-rating').forEach(function (sp) {
    var m = sp.textContent.match(/(\d+[,.]\d)\s*\/\s*10/);
    if (m) sp.insertAdjacentHTML('afterend', '<span class="kb-scorebar"><i style="--s:' + (num(m[1]) * 10) + '%"></i></span>');
  });
  content.querySelectorAll('table tbody tr').forEach(function (tr, i) { tr.classList.add('kb-reveal'); tr.style.transitionDelay = Math.min(i, 8) * 0.05 + 's'; });

  } catch (e) { console.warn("kb-pro F)", e); }
  try {
  /* G) Produktblöcke: Kopf mit Notenring */
  content.querySelectorAll('.smt-review > h3').forEach(function (h3) {
    var m = h3.textContent.trim().match(/^(?:\d+\.\d+\s+)?(.+?)\s*\((\d+[,.]\d)\s*\/\s*10\)\s*$/);
    var head = document.createElement('div');
    head.className = 'kb-rev-head';
    h3.parentNode.insertBefore(head, h3);
    var badge = head.previousElementSibling;
    var txt = document.createElement('div');
    txt.className = 'kb-rev-head__t';
    if (badge && badge.classList.contains('smt-badge')) txt.appendChild(badge);
    txt.appendChild(h3);
    head.appendChild(txt);
    if (m) {
      h3.textContent = m[1];
      head.insertAdjacentHTML('beforeend', '<div class="kb-rev-score">' + ring(num(m[2]), 10, m[2]) + '<small>/10</small></div>');
    } else {
      h3.textContent = h3.textContent.replace(/^\d+\.\d+\s+/, '');
    }
  });

  } catch (e) { console.warn("kb-pro G)", e); }
  try {
  /* H) Listen aufwerten */
  content.querySelectorAll(':scope > ul, .kb-crit > ul').forEach(function (ul) {
    var lis = Array.prototype.slice.call(ul.children);
    if (!lis.length) return;
    var allStrong = lis.every(function (li) { var f = li.firstElementChild; return f && f.tagName === 'STRONG' && li.textContent.trim().indexOf(f.textContent.trim()) === 0; });
    var allQ = lis.every(function (li) { return /\?\s*$/.test(li.textContent.trim()); });
    if (allStrong && lis.length === 3 && lis.every(function (li) { return /:\s*$/.test(li.firstElementChild.textContent); })) {
      ul.classList.add('kb-sev', 'kb-reveal');
    } else if (allStrong && lis.length >= 4 && strict) {
      ul.classList.add('kb-rules', 'kb-rules--plain');
      lis.forEach(function (li, i) { li.classList.add('kb-reveal'); li.style.transitionDelay = (i % 2) * 0.08 + 's'; });
    } else if (allStrong && lis.length >= 4) {
      ul.classList.add('kb-rules');
      lis.forEach(function (li, i) { li.classList.add('kb-reveal'); li.style.transitionDelay = (i % 2) * 0.08 + 's'; li.insertAdjacentHTML('afterbegin', '<span class="kb-rules__n">' + (i + 1) + '</span>'); });
    } else if (allQ && lis.length >= 3) {
      ul.classList.add('kb-check', 'kb-reveal');
    }
  });

  } catch (e) { console.warn("kb-pro H)", e); }
  try {
  /* I) "Für wen"-Absätze als Karten */
  var run = [];
  var flush = function () {
    if (run.length >= 3 && strict) {
      run.forEach(function (para, i) { para.classList.add('kb-pcard', 'kb-reveal'); para.style.transitionDelay = (i % 2) * 0.08 + 's'; });
    } else if (run.length >= 3) {
      var g = document.createElement('div');
      g.className = 'kb-personas';
      run[0].parentNode.insertBefore(g, run[0]);
      run.forEach(function (para, i) {
        var st = para.querySelector('strong');
        var card = document.createElement('div');
        card.className = 'kb-persona kb-reveal';
        card.style.transitionDelay = (i % 2) * 0.08 + 's';
        var t = document.createElement('div');
        t.className = 'kb-persona__t';
        t.textContent = st.textContent.replace(/:\s*$/, '');
        st.remove();
        para.innerHTML = para.innerHTML.replace(/^\s*(&nbsp;|\s)*/, '');
        card.appendChild(t);
        card.appendChild(para);
        g.appendChild(card);
      });
    }
    run = [];
  };
  kids().forEach(function (el) {
    var f = el.firstElementChild;
    if (el.tagName === 'P' && f && f.tagName === 'STRONG' && /:\s*$/.test(f.textContent) && el.textContent.trim().indexOf(f.textContent.trim()) === 0) run.push(el);
    else flush();
  });
  flush();

  } catch (e) { console.warn("kb-pro I)", e); }
  try {
  /* J) Hinweis-Kästen, Bilder, Überschriften: Einblenden */
  content.querySelectorAll('.kb-scorecard, .kb-vs, .smt-info, .smt-warn, .smt-trust, .smt-review, .kb-buy, .kb-yt, :scope > img, .smt-review > img, :scope > h3, .smt-procon, .kco-info, .kco-warning, .kco-danger, .kco-check, .kco-trust, .kco-card, .kco-proof, .kco-featured, .kco-figure, .kco-stats, :scope > div[style*="overflow"]').forEach(function (el) { el.classList.add('kb-reveal'); });
  content.querySelectorAll('.kco-info').forEach(function (el) { el.classList.add('kb-note', 'kb-note--info'); });
  content.querySelectorAll('.kco-warning, .kco-danger').forEach(function (el) { el.classList.add('kb-note', 'kb-note--warn'); });
  content.querySelectorAll('.kco-check, .kco-trust').forEach(function (el) { el.classList.add('kb-note', 'kb-note--doc'); });
  content.querySelectorAll('table.kco-table').forEach(function (t) { t.classList.add('smt-table'); });
  content.querySelectorAll('.smt-info').forEach(function (el) { el.classList.add('kb-note', 'kb-note--info'); });
  content.querySelectorAll('.smt-warn').forEach(function (el) { el.classList.add('kb-note', 'kb-note--warn'); });
  content.querySelectorAll('.smt-trust:not(.kb-footnote)').forEach(function (el) { el.classList.add('kb-note', 'kb-note--doc'); });

  } catch (e) { console.warn("kb-pro J)", e); }
  try {
  /* K) kr-Beiträge: Kästen, Bildrahmen, Checkliste, Linkkarten (Text bleibt unverändert) */
  if (kr) {
    content.querySelectorAll('.kr-snippet, .kr-info, .kr-warn, .kr-check, .kr-trust, .kr-review, .kr-note, table.kr-table').forEach(function (el) { el.classList.add('kb-reveal'); });
    content.querySelectorAll('.kr-info').forEach(function (el) { el.classList.add('kb-note', 'kb-note--info'); });
    content.querySelectorAll('.kr-warn').forEach(function (el) { el.classList.add('kb-note', 'kb-note--warn'); });
    content.querySelectorAll('.kr-check').forEach(function (el) { el.classList.add('kb-note', 'kb-note--ok'); });
    content.querySelectorAll('table.kr-table').forEach(function (t) { t.classList.add('smt-table'); });
    content.querySelectorAll('.kr-check > ul').forEach(function (ul) { ul.classList.add('kb-check'); ul.removeAttribute('style'); });
    content.querySelectorAll(':scope > img').forEach(function (img) {
      var cap = img.nextElementSibling;
      var fig = document.createElement('div');
      fig.className = 'kb-fig kb-reveal';
      img.parentNode.insertBefore(fig, img);
      fig.appendChild(img);
      if (cap && cap.classList.contains('kr-img-caption')) fig.appendChild(cap);
      img.classList.remove('kb-reveal');
    });
    content.querySelectorAll(':scope > ul').forEach(function (ul) {
      var lis = Array.prototype.slice.call(ul.children);
      if (lis.length && lis.every(function (li) { var a = li.querySelector('a'); return a && a.textContent.trim() === li.textContent.trim(); })) {
        ul.classList.add('kb-links');
        lis.forEach(function (li, i) { li.classList.add('kb-reveal'); li.style.transitionDelay = (i % 2) * 0.08 + 's'; });
      }
    });
  }

  } catch (e) { console.warn("kb-pro K)", e); }
  try {
  /* Lesefortschritt */
  var prog = document.createElement('div');
  prog.className = 'kb-progress';
  document.body.appendChild(prog);
  var onProg = function () {
    var r = content.getBoundingClientRect(), h = r.height - window.innerHeight;
    var v = h > 0 ? Math.min(1, Math.max(0, -r.top / h)) : 0;
    prog.style.transform = 'scaleX(' + v.toFixed(4) + ')';
  };
  window.addEventListener('scroll', onProg, { passive: true });
  onProg();

  } catch (e) { console.warn("kb-pro Lesef", e); }
  try {
  /* Einblenden beim Scrollen */
  var rev = root.querySelectorAll('.kb-reveal, .kb-ring, .kb-wbar, .kb-scorebar');
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    root.classList.add('kb-anim');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    rev.forEach(function (el) { io.observe(el); });
  } else {
    rev.forEach(function (el) { el.classList.add('is-in'); });
  }
  } catch (e) { console.warn("kb-pro Einbl", e); }
})();
